// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__2Db0d","text":"styles_text__AsBkg","activeButton":"styles_activeButton__k7Heo"};